import i18n from '../../localization/i18n';
import type { BarcodeActionError } from '../types/BarcodeAction';

export function wrongBasePaintError(basecode: string): BarcodeActionError {
  return {
    title: i18n.t('msg.barcodeValidWrongBase.title', 'Wrong base paint'),
    msg: i18n.t(
      'msg.barcodeValidWrongBase',
      'The scanned base paint is not compatible with the selected color. Please use base {{basecode}}.',
      { basecode }
    ),
  };
}
